<div class="about-container">
  <div class="main-logos">
    <img src="assets/tecseo.jpg" alt="Tecseo" />
    <img src="assets/key4.png" alt="Key4" />
  </div>

  <div class="sep-line"></div>

  <h1>Progetto 17184 - MOTION</h1>
  <h2>Nuovo Business Model abilitato dal Framework AI-based per una innovativa soluzione di mobilità condivisa</h2>

  <div class="goals-box">
    <p>
      <b>SPOKE 4 - Smart mobility, housing and energy solutions - Tema 2</b
      ><br />
      Progettazione per tutti, città sana e attiva, social-housing design,<br />
      cambiamenti comportamentali, innovazioni tecnologiche e sociali,<br />
      valutazione delle politiche climatiche
    </p>
  </div>

  <div class="sep-line"></div>


  <img class="secondary-logos" src="assets/secondarylogos.jpeg" alt="Loghi secondari" />

  <!-- <div class="secondary-logos">
    <img src="" alt="NextGenerationEU" />
    <img src="" alt="Ministero dell'università e della ricerca" />
    <img src="" alt="Italiadomani" />
  </div> -->
</div>
